// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-7403001b]{border:none;padding:0;margin-top:0;display:-webkit-box;display:-ms-flexbox;display:flex}i[data-v-7403001b],img[data-v-7403001b]{margin:5px 10px;width:15px}", ""]);
// Exports
module.exports = exports;
